import { apiGet, apiPost, apiPatch, apiDelete } from './api';

export interface LeadGroup {
  id: string;
  tenantId: string;
  name: string;
  source: 'manual' | 'csv' | 'ai';
  createdAt: string;
  leadCount: number;
  sentCount: number;
}

export async function getLeadGroups(): Promise<LeadGroup[]> {
  return apiGet<LeadGroup[]>('/lead-groups');
}

export async function getLeadGroup(id: string): Promise<LeadGroup> {
  return apiGet<LeadGroup>(`/lead-groups/${id}`);
}

export async function createLeadGroup(data: { name: string; source?: string }): Promise<LeadGroup> {
  return apiPost<LeadGroup>('/lead-groups', data);
}

export async function updateLeadGroup(id: string, data: { name?: string }): Promise<LeadGroup> {
  return apiPatch<LeadGroup>(`/lead-groups/${id}`, data);
}

export async function deleteLeadGroup(id: string): Promise<void> {
  await apiDelete(`/lead-groups/${id}`);
}

export async function getLeadGroupLeads(groupId: string): Promise<unknown[]> {
  return apiGet<unknown[]>(`/lead-groups/${groupId}/leads`);
}
